import { Typography } from "@circleco/compass/components/Typography";

import { CircleAIBuildNavGroup } from "./CircleAIBuildNavGroup";
import { CircleAIBuildNavRow } from "./CircleAIBuildNavRow";
import type { BuildNavItem } from "./types";

interface CircleAIBuildNavSectionProps {
  items: BuildNavItem[];
  onToggleGroup: (id: string) => void;
  openGroupId: string | undefined;
  title?: string;
}

export const CircleAIBuildNavSection = ({
  items,
  onToggleGroup,
  openGroupId,
  title,
}: CircleAIBuildNavSectionProps) => {
  if (items.length === 0) return null;

  return (
    <div className="flex flex-col gap-0.5 px-3 py-2">
      {title && (
        <Typography
          variant="heading-xs"
          color="tertiary"
          component="h2"
          className="px-3 pb-1 pt-2"
        >
          {title}
        </Typography>
      )}
      {items.map(item =>
        item.children?.length ? (
          <CircleAIBuildNavGroup
            key={item.id}
            item={item}
            isOpen={openGroupId === item.id}
            onToggle={() => onToggleGroup(item.id)}
          />
        ) : (
          <CircleAIBuildNavRow key={item.id} item={item} />
        ),
      )}
    </div>
  );
};
